import Repository from './Repository.js';

class PartnersRepository extends Repository {
    async getPartners(query) {
        return await this.get('partners', query);
    }
}

export default new PartnersRepository();
